import React, { useEffect, useState } from "react";
import Header from "../../../components/Header/Header";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import {
  Box,
  FormControl,
  Grid,
  IconButton,
  InputBase,
  InputLabel,
  MenuItem,
  Select,
  CircularProgress,
} from "@mui/material";
import Tables from "../../../components/Table/Table";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as acts from "../../../redux/administrator/actions";
import AdministratorHeader from "../../../components/Header/AdministratorHeader";
import "./outPutFormat.scss";
import TablePagination from "@mui/material/TablePagination";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import DateRangePicker from "../../../components/DateRangePicker";
import moment from "moment";
import SearchBar from "../../../components/Controls/SearchBar/SearchBar";
import TableSkeleton from "../../../components/Skeletons/TableSkeleton";
import ClearIcon from "@mui/icons-material/Clear";
import { action } from "../../../constants/action";
import SearchIcon from "@mui/icons-material/Search";
import Buttons from "../../../components/Controls/Buttons/Button";
import { adminRoutes } from "../../../routes/routeConstants";

const Index = () => {
  const listData = useSelector((state) => state?.admin?.outPutData?.data);
  const Dispatch = useDispatch();
  const navigate = useNavigate();
  const [pageCount, setPageCount] = useState(listData?.total_count || 0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [outputData, setOutputData] = useState([]);
  const [page, setPage] = useState(0);
  const apiStatus = useSelector((state) => state?.admin?.outPutData);
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);
  const [fileType, setFileType] = useState("");
  const [status, setStatus] = useState("");
  const [sDate, setSDate] = useState("");
  const [eDate, setEDate] = useState("");
  const [type, setType] = useState("project");
  const [value, setValue] = useState("");
  const [fileValue, setFileValue] = useState("");

  const [selectedRows, setSelectedRows] = useState([]);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [success, setSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    Dispatch(acts.ClearOutPutListApiStatus());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const data = {
      page: page + 1,
      page_size: rowsPerPage,
      fileType,
      status,
      formattedStartDate: sDate,
      formattedEndDate: eDate,
      // ...(type !== null && {
      //   [type === "project" ? "projectName" : "batchName"]: value,
      // }),
      type,
      value,
      fileValue,
    };
    Dispatch(acts.getOutPutList(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Dispatch, rowsPerPage]);

  useEffect(() => {
    const data = {
      page: page + 1,
      page_size: rowsPerPage,
      fileType,
      status,
      formattedStartDate: sDate,
      formattedEndDate: eDate,
      // ...(type !== null && {
      //   [type === "project" ? "projectName" : "batchName"]: value,
      // }),
      type,
      value,
      fileValue,
    };
    Dispatch(acts.getOutPutList(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    //Success and error notification
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus?.apiError === true && apiStatus?.next === false) {
        setMessage(apiStatus?.message);
        setErr(true);
      }
    }
  }, [apiStatus]);

  useEffect(() => {
    setOutputData(listData?.data);
    setPageCount(listData?.total_count);
  }, [listData]);

  const handleChange = (event) => {
    setType(event.target.value);
    setValue("");
  };

  const handlePageChange = (event, pageNo) => {
    setPage(pageNo);
    Dispatch(
      acts.getOutPutList({
        page: pageNo + 1,
        page_size: rowsPerPage,
        fileType,
        status,
        formattedStartDate: sDate,
        formattedEndDate: eDate,
        // ...(type !== null && {
        //   [type === "project" ? "projectName" : "batchName"]: value,
        // }),
        type,
        value,
        fileValue,
      }),
    );
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
    setPageCount(listData?.total_count);
  };

  const newScreenNavigatin = () => {
    Dispatch(acts.getDpDetails());
    navigate(`/${adminRoutes.dataPointDetails}`)
  };
  const filterByDate = (startDate, endDate) => {
    const formattedStartDate = startDate
      ? moment(startDate).format("YYYY-MM-DD")
      : "";
    const formattedEndDate = endDate
      ? moment(endDate).format("YYYY-MM-DD")
      : "";
    setSDate(formattedStartDate);
    setEDate(formattedEndDate);

    const data = {
      page: page + 1,
      page_size: rowsPerPage,
      fileType,
      status,
      formattedStartDate: formattedStartDate,
      formattedEndDate: formattedEndDate,
      // ...(type !== null && {
      //   [type === "project" ? "projectName" : "batchName"]: value,
      // }),
      type,
      value,
      fileValue,
    };
    Dispatch(acts.getOutPutList(data));
  };
  const clear = () => {};
  const handleFileType = (event) => {
    setFileType(event.target.value);
  };
  const handleStatus = (event) => {
    setStatus(event.target.value);
  };

  const onChangeValue = (value) => {
    setValue(value);
  };

  const onChangeFileValue = (value) => {
    setFileValue(value);
  };

  const clearFileType = () => {
    setFileType("");
  };

  const clearStatus = () => {
    setStatus("");
  };

  const clearValue = () => {
    setValue("");
  };

  const clearFileValue = () => {
    setFileValue("");
  };

  const handleSubmitToSRM = async () => {
    try {
      setSubmitLoader(true);
      const res = await Dispatch(acts.submitFilesForSRM(selectedRows));
      setSubmitLoader(false);
      setSuccess(true);
      setSuccessMsg("Files submitted successfully to SRM!");
    } catch (err) {
      setSubmitLoader(false);
      setErr(true);
      setMessage("Failed to submit files to SRM. Please try again.");
    }
  };

  const handleRefresh = () => {
    const data = {
      page: page + 1,
      page_size: rowsPerPage,
      fileType,
      status,
      formattedStartDate: sDate,
      formattedEndDate: eDate,
      // ...(type !== null && {
      //   [type === "project" ? "projectName" : "batchName"]: value,
      // }),
      type,
      value,
      fileValue,
    };
    Dispatch(acts.getOutPutList(data));
  };

  return (
    <>
      <Header />
      <Box className="manage-output-files">
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          {/* <Grid className="manage-output-conatiner" item md={9} sm={8}> */}
          <Grid className="visualization-conatiner manage-output-conatiner">
            <AdministratorHeader
              text="Manage Output Files"
              outPutButton={"Data Point Details"}
              Click={newScreenNavigatin}
            />
            <Grid
              container
              className="input-wrap-container"
              alignItems="center"
              wrap="nowrap"
              spacing={1}
            >
              <Grid item md={3} sx={{ padding: "0px !important" }}>
                <div className="search-container">
                  <div>
                    <FormControl>
                      <Select
                        className="dropdown-input-select"
                        labelId="demo-simple-select-autowidth-label"
                        id="demo-simple-select-autowidth"
                        value={type}
                        onChange={handleChange}
                        autoWidth
                      >
                        <MenuItem value="project" selected={true}>
                          {action.PROJECT}
                        </MenuItem>
                        <MenuItem value="batch">{action.BATCH}</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="search">
                    {/* <div className="search-wrapper">
                      <SearchIcon />
                    </div> */}
                    <FormControl>
                      <InputBase
                        id="searchInput"
                        className="input-style"
                        placeholder={`${action.SEARCH}  ${
                          type === "project" ? action.PROJECT : action.BATCH
                        } `}
                        inputProps={{ "aria-label": "search" }}
                        onChange={
                          (event) => onChangeValue(event.target.value)
                          // onSearch(event.target.value, type)
                        }
                        value={value}
                      />
                      {value && (
                        <IconButton
                          onClick={() => clearValue()}
                          size="small"
                          style={{
                            position: "absolute",
                            top: "50%",
                            right: 1,
                            transform: "translateY(-50%)",
                          }}
                        >
                          <ClearIcon />
                        </IconButton>
                      )}
                    </FormControl>
                  </div>
                </div>

                {/* <SearchBar onSearch={(value, type) => onSearch(value, type)} /> */}
              </Grid>

              <Grid item md={2} sx={{ padding: "0px !important" }}>
                <div className="search file-name-search">
                  {/* <div className="search-wrapper">
                      <SearchIcon />
                    </div> */}
                  <FormControl>
                    <InputBase
                      id="searchInput"
                      className="input-style"
                      placeholder={action.FILE_NAME_SEARCH}
                      inputProps={{ "aria-label": "search" }}
                      onChange={
                        (event) => onChangeFileValue(event.target.value)
                        // onSearch(event.target.value, type)
                      }
                      value={fileValue}
                    />
                    {fileValue && (
                      <IconButton
                        onClick={() => clearFileValue()}
                        size="small"
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: 1,
                          transform: "translateY(-50%)",
                        }}
                      >
                        <ClearIcon />
                      </IconButton>
                    )}
                  </FormControl>
                </div>
              </Grid>

              <Grid item md={1} sx={{ padding: "0px !important" }}>
                <FormControl fullWidth>
                  <InputLabel
                    className="multiplecontrolsLabel"
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name-label"
                  >
                    File Type
                  </InputLabel>
                  <Select
                    className="b-0"
                    size="small"
                    label="File Type"
                    value={fileType}
                    onChange={handleFileType}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="xlsx">xlsx</MenuItem>
                    <MenuItem value="pdf">pdf</MenuItem>
                    <MenuItem value="csv">csv</MenuItem>
                    <MenuItem value="json">json</MenuItem>
                  </Select>
                  {fileType && (
                    <IconButton
                      onClick={() => clearFileType()}
                      size="small"
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: 25,
                        transform: "translateY(-50%)",
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  )}
                </FormControl>
              </Grid>
              <Grid
                item
                md={1.4}
                className="input-wrap-container-select"
                sx={{ padding: "0px !important" }}
              >
                <FormControl fullWidth>
                  <InputLabel
                    className="multiplecontrolsLabel"
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name-label"
                  >
                    {" "}
                    Status
                  </InputLabel>
                  <Select
                    className="b-0"
                    label="Status"
                    size="small"
                    value={status}
                    onChange={handleStatus}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="approved">Approved</MenuItem>
                    <MenuItem value="rejected">Rejected</MenuItem>
                    <MenuItem value="unapproved">Unapproved</MenuItem>
                  </Select>
                  {status && (
                    <IconButton
                      onClick={() => clearStatus()}
                      size="small"
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: 25,
                        transform: "translateY(-50%)",
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  )}
                </FormControl>
              </Grid>
              <Grid
                item
                md={3}
                className="z-999"
                sx={{ padding: "0px !important" }}
              >
                <DateRangePicker filterByDate={filterByDate} clear={clear} />
              </Grid>

              <Grid item md={1.8} sx={{ padding: "0px !important" }}>
                <Buttons
                  className="btn-search"
                  text={
                    submitLoader ? (
                      <>
                        <CircularProgress
                          size={18}
                          sx={{ color: "white", marginRight: 1 }}
                        />
                        Submitting...
                      </>
                    ) : (
                      "Submit to SRM"
                    )
                  }
                  onClick={handleSubmitToSRM}
                  disabled={submitLoader || selectedRows?.length === 0} // ✅ Disable when loading or no selection
                  sx={{
                    minWidth: 180,
                    opacity: submitLoader ? 0.8 : 1,
                    cursor: submitLoader ? "not-allowed" : "pointer",
                  }}
                ></Buttons>
              </Grid>
            </Grid>

            <Box className="manage-data-list">
              {apiStatus?.loader ? (
                <TableSkeleton />
              ) : (
                <Tables
                  data={outputData}
                  showDPCalculationMenu={true}
                  handleRefresh={() => handleRefresh()}
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                />
              )}
            </Box>

            <Grid className="pagination-wrap">
              <TablePagination
                rowsPerPageOptions={[100, 200, 300, 500]}
                component="div"
                count={pageCount}
                page={parseInt(page)}
                onPageChange={handlePageChange}
                rowsPerPage={parseInt(rowsPerPage)}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {err && (
        <CustomizedSnackbars
          severity="error"
          state={err}
          text={message}
          handleClose={() => setErr(false)}
        />
      )}

      {success && (
        <CustomizedSnackbars
          severity="success"
          state={success}
          text={successMsg}
          handleClose={() => setSuccess(false)}
        />
      )}
    </>
  );
};

export default Index;
